<script lang="ts">
  import type { TGetAssetsResult } from "../../../passport-evm/src/utils/types";
  import ContentHeader from "../shared/ContentHeader.svelte";
  import Loader from "../shared/Loader.svelte";
  import ActiveAsset from "./ActiveAsset.svelte";
  import AssetItem from "./AssetItem.svelte";

  let {
    options,
    isLoading,
  }: {
    isLoading: boolean;
    options: {
      title: string;
      description: string;
      assets: TGetAssetsResult;
    };
  } = $props();
  let activeAsset: any = $state(null);

  function closeActiveAsset() {
    activeAsset = null;
  }

  // keep for now for tests
  // $effect(() => {
  //   if (options.assets.length === 1) {
  //     options.assets[0].metadata.image =
  //       'ipfs://bafybeigdyrzt5sfp7udm7hu76uh7y26nf3efuylqabf3oclgtqy55fbzdi'
  //       //"https://upload.wikimedia.org/wikipedia/commons/5/5c/1838_or_1839_Frauenkirche_Munich_-_Steinheil_and_Kobell_1.png";
  //     console.log(options.assets[0]);
  //     console.log(options.assets[0].metadata.image);
  //     const opts = (options = {
  //       ...options,
  //       assets: Array(11).fill(options.assets[0]),
  //     });
  //     options = opts;
  //   }
  // });
</script>

{#if isLoading}
  <Loader />
{:else if activeAsset}
  <ActiveAsset asset={activeAsset} onClose={closeActiveAsset} />
{:else if !options.assets?.length}
  <ContentHeader text={options.title} description={options.description} />
  <div class="crtw-w-full crtw-text-center">You don't have any assets yet.</div>
{:else}
  <ContentHeader text={options.title} description={options.description} />
  <div
    class="crtw-flex crtw-flex-wrap crtw-justify-center crtw-w-full crtw-gap-2"
  >
    {#each options.assets as asset}
      <AssetItem {asset} onSelect={(a) => (activeAsset = a)} />
    {/each}
  </div>
{/if}
